/**
 * Runtime API base URL resolver.
 * 
 * Problem: REACT_APP_BACKEND_URL is baked into the JS bundle at build time.
 * When the app is deployed to a production domain (e.g., tdfxcapital.com),
 * the baked-in URL points to the old preview URL, causing all API calls to fail.
 * 
 * Solution: At runtime, detect if we're on a different domain than the baked-in
 * URL. If so, use relative URLs (empty string), which route through the same
 * domain's /api/* path — which works on both preview and production.
 */
const getApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL || '';
  if (!envUrl) return '';
  try {
    const envOrigin = new URL(envUrl).origin;
    if (typeof window !== 'undefined' && window.location.origin !== envOrigin) {
      return '';
    }
  } catch {
    return '';
  }
  return envUrl;
};

export const API_BASE_URL = getApiBaseUrl();
